import { render, staticRenderFns } from "./CompanyAddresses.vue?vue&type=template&id=d1baeb3a&scoped=true&"
import script from "./CompanyAddresses.vue?vue&type=script&lang=js&"
export * from "./CompanyAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1baeb3a",
  null
  
)

export default component.exports